'use client';

import { getClassNames, isBrowser } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmPin, IconLlmTimetable } from '@websolutespa/bom-mixer-icons';
import { LlmBlock, LlmChunkPoi, LlmChunkPoiItem } from '../../../types';
import { useLlm } from '../../../useLlm/useLlm';
import { useLlmView } from '../../../useLlm/useLlmView';
import { Cta } from '../../components/Cta/cta';

export const Poi: React.FC<LlmBlock<LlmChunkPoiItem | LlmChunkPoi>> = (props) => {
  const { item } = props;
  const label = useLabel();
  const { decorateUrl } = useLlm(state => state.actions);
  const { send } = useLlmView(state => state.actions);
  const onTellMeMore = async (event: React.MouseEvent) => {
    const prompt = `${label('llm.tellMeMoreAbout')} ${item.title}`;
    await send(prompt, (response) => {
      // console.log('Prompt.onChunk', response.chunks);
    }, (response) => {
      // console.log('Prompt.onEnd', response);
    });
  };
  const onGoToWebsite = async (event: React.MouseEvent) => {
    if (isBrowser) {
      event.preventDefault();
      const url = await decorateUrl(item, item.url);
      window.open(url, '_blank');
    }
  };
  const classNames = getClassNames('llm__poi', { [`llm__poi--${item.type}`]: !!item.type });
  return (
    <div className={classNames}>
      {item.image && (
        <div className="llm__poi-media">
          <img src={item.image} alt="" />
        </div>
      )}
      <div className="llm__poi-content">
        {item.title && (
          <div className="llm__poi-title" dangerouslySetInnerHTML={{ __html: item.title }} />
        )}
        {item.abstract && (
          <div className="llm__poi-body" dangerouslySetInnerHTML={{ __html: item.abstract }} />
        )}
        {(item.time || item.place) && (
          <div className="llm__poi-tags">
            {item.time && (
              <div className="llm__poi-tag llm__poi-time"><IconLlmTimetable />{item.time}</div>
            )}
            {item.place && (
              <div className="llm__poi-tag llm__poi-location"><IconLlmPin />{item.place}</div>
            )}
          </div>
        )}
        <div className="llm__poi-ctas">
          <Cta type="button" label={label('llm.tellMeMore')} onClick={onTellMeMore} />
          <Cta type="text" label={label('llm.goToWebsite')} onClick={onGoToWebsite} />
        </div>
      </div>
    </div>
  );
};

